module.exports = __webpack_public_path__ + "static/img/quizzes_bg1400.fcd749d2.jpg";